<template>
  <v-app>
    <core-app-bar
      v-if="drawerAndAppBarDisabledRoutes.indexOf($router.currentRoute.name) == -1"
      @setLoadingSites="setLoadingSites"
    />

    <core-drawer
      v-if="drawerAndAppBarDisabledRoutes.indexOf($router.currentRoute.name) == -1"
    />

    <site-required
      v-if="siteRequiredRoutes.indexOf($router.currentRoute.name) > -1 && !site"
      :key="updateKey + '-site-required'"
      :loading="loadingSites"
    />
    <core-view
      v-else
      :key="updateKey + '-core-view'"
    />

    <v-snackbar
      v-model="snackbar"
      :color="color"
      bottom
      right
      :timeout="5000"
      dark
    >
      <v-icon
        color="white"
        class="mr-3"
      >
        mdi-information-outline
      </v-icon>
      {{ message }}
      <v-btn
        icon
        @click="snackbar = false"
      >
        <v-icon>
          mdi-close-circle
        </v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
  import moment from 'moment'
  import SiteRequired from '@/components/SiteRequired.vue'
  export default {
    components: {
      CoreDrawer: () => import('@/components/core/Drawer'),
      // CoreFooter: () => import('@/components/core/Footer'),
      CoreAppBar: () => import('@/components/core/AppBar'),
      CoreView: () => import('@/components/core/View'),
      SiteRequired
    },
    data () {
      var drawerAndAppBarDisabledRoutes = ['Login']
      var siteRequiredRoutes = ['Dashboard', 'Schemas', 'Forms', 'Mail', 'Content', 'Orders', 'Translations']
      return {
        drawerAndAppBarDisabledRoutes,
        siteRequiredRoutes,
        snackbar: false,
        loadingSites: false,
        error: null,
        message: null,
        updateKey: 0,
        color: 'primary',
        cancels: []
      }
    },
    computed: {
      user: function () {
        return this.$store.state.user
      },
      site: function () {
        return this.$store.state.site
      }
    },
    watch: {
      site () {
        if (this.siteRequiredRoutes.indexOf(this.$router.currentRoute.name) > -1) {
          this.updateKey++
        }
      },
      $route (to, from) {
        if (to.meta && to.meta.requireAuth) {
          if (this.user && this.user.lastLogin && this.moment(this.user.lastLogin).add(7, 'days').isBefore(this.moment())) {
            this.snack('Your session has expired, please log in again', 'error')
            this.$router.push('/login?logout=1&redirect=' + this.$route.path)
          }
        }

        if (to.path !== from.path) {
          this.cancels.forEach(cancel => {
            cancel()
          })
          this.cancels = []
          document.title = 'BetaCore Portal | ' + to.name
          this.updateKey++
        }
      }
    },
    created () {
      // set name so email can target this window!
      window.name = 'BetaCore Portal'

      if (this.user) {
        this.api.defaults.headers.Authorization = 'Bearer ' + this.user.token
      }

      // var CancelToken = this.api.CancelToken
      this.api.interceptors.response.use(res => {
        return res
      }, error => {
        var message = 'Something went wrong, please try again later.'
        var unauthorized = false
        if (error.response) {
          if (error.response.config.baseURL.indexOf('localhost') > -1) {
            if (error.response.status === 401) {
              message = 'You\'re not authorized'
              unauthorized = true
            } else {
              var errorMessage = error.response.data.split('\n')[0]
              errorMessage = errorMessage.replace('System.Exception: ', '')
              message = errorMessage
            }
          }
        }
        this.snack(message, 'error')
        if (unauthorized) {
          this.$router.push('/login?logout=1&redirect=' + this.$route.path)
        }
        return Promise.reject(error)
      })
    },
    methods: {
      moment,
      setLoadingSites (value) {
        this.loadingSites = value
      },
      snack (message, color) {
        var timeout = 0
        if (this.snackbar) {
          this.snackbar = false
          timeout = 250
        }
        setTimeout(() => {
          this.color = color
          this.message = message
          this.snackbar = true
        }, timeout)
      },
    }
  }
</script>

<style>
.v-application * .v-btn:not(.v-btn--round),
.v-application * .v-card,
.v-application * .v-list,
.v-application * .v-list-item,
.v-application * .v-menu__content,
.v-application * .v-alert,
.v-application * .v-text-field--solo,
.v-application * .v-expansion-panels,
.v-application * .v-expansion-panel--active,
.v-application * .v-data-table,
.v-menu__content,
.v-application * .v-list-item::before
 {
  border-radius: 0 !important;
}

.v-application .v-list-item--active::before {
  opacity: 0 !important;
}

.v-application {
  background: url('assets/deco.svg') no-repeat  center center !important;
  background-color: var(--v-secondary-base) !important;
  background-size: cover !important;
}

.v-application .jsoneditor,
.v-application .jsoneditor-navigation-bar,
.v-application .v-card,
.v-application .v-small-dialog__menu-content,
.v-application .v-navigation-drawer,
.v-application .v-text-field--solo {
   background-color: var(--v-secondary-base) !important;
   border: 1px  solid !important;
   border-color: var(--v-primary-base) !important;
   box-shadow: none !important;
}

.v-application .v-select-list,
.v-application .v-data-table,
.v-application .v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: var(--v-secondary-base) !important;
}

.v-application .jsoneditor-menu,
.v-application .jsoneditor-frame {
    background-color: var(--v-primary-base) !important;
    border-bottom: none;
}

.v-application .jsoneditor-menu >  .jsoneditor-modes>button,
.v-application .jsoneditor-menu > button {
  opacity: unset;
}
.v-application .v-list:not(.v-select-list) {
  background-color: transparent !important;
}

.v-application div.jsoneditor-value.jsoneditor-string {
  color: var(--v-primary-base);
}
.v-application .primary,
.v-application .tertiary {
  color: var(--v-secondary-base) !important;
}

.v-application .v-dialog {
      overflow: visible;
}

.v-application .quillWrapper .ql-snow .ql-picker-label,
.v-application .quillWrapper .ql-snow .ql-fill,
.v-application .quillWrapper .ql-snow .ql-stroke {
  color: #ffffff;
  stroke: rgba(255,255,255,.85);
}

.v-application .quillWrapper .ql-snow.ql-toolbar button:hover .ql-stroke,
.v-application .quillWrapper .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.v-application .quillWrapper  .ql-snow.ql-toolbar .ql-picker-label:hover
 {
  color: var(--v-info-base);
  stroke: var(--v-info-base);
}

.v-application .quillWrapper .ql-snow .ql-picker-label.ql-active ,
.v-application .quillWrapper .ql-snow .ql-picker-label.ql-active .ql-stroke,
.v-application .quillWrapper .ql-snow .ql-active .ql-fill,
.v-application .quillWrapper .ql-snow .ql-active .ql-stroke {
  color: var(--v-info-base);
  stroke: var(--v-info-base);
}

.v-application .quillWrapper .ql-snow .ql-color-label {
  opacity: 1 !important;
}

@media (pointer: coarse) {
  .v-application .quillWrapper .ql-snow button:hover:not(.ql-active) .ql-fill,
  .v-application .quillWrapper .ql-snow button:hover:not(.ql-active) .ql-stroke {
    stroke: rgba(255,255,255,.85);
  }
}
.v-application .jsoneditor-popover,
.v-application .jsoneditor-schema-error,
.v-application div.jsoneditor-field,
.v-application div.jsoneditor-value,
.v-application div.jsoneditor td,
.v-application div.jsoneditor textarea,
.v-application div.jsoneditor th,
.v-application pre.jsoneditor-preview,
.v-application .quillWrapper .ql-picker-label {
    color: #fff;
}
.v-application .quillWrapper .ql-container {
  border: none;
}
.v-application .quillWrapper .ql-toolbar,
.v-application .quillWrapper .ql-editor {
  border: 1px solid var(--v-primary-base);
}
</style>
